/**
 * Project member management API.
 */

import { apiClient } from "./client";

export interface ProjectMember {
  id: string;
  project_id: string;
  user_id: string;
  role: "owner" | "admin" | "editor" | "viewer";
  display_name: string | null;
  email: string | null;
  invited_by: string | null;
  invited_at: string | null;
  accepted_at: string | null;
  pending: boolean;
}

export interface InviteMemberBody {
  email: string;
  role: "admin" | "editor" | "viewer";
  display_name?: string;
}

export async function fetchMembers(projectId: string): Promise<ProjectMember[]> {
  return apiClient<ProjectMember[]>(`/projects/${projectId}/members`);
}

export async function inviteMember(
  projectId: string,
  body: InviteMemberBody,
): Promise<ProjectMember> {
  return apiClient<ProjectMember>(`/projects/${projectId}/members`, {
    method: "POST",
    body,
  });
}

export async function updateMemberRole(
  projectId: string,
  memberId: string,
  role: string,
): Promise<ProjectMember> {
  return apiClient<ProjectMember>(`/projects/${projectId}/members/${memberId}`, {
    method: "PATCH",
    body: { role },
  });
}

export async function removeMember(
  projectId: string,
  memberId: string,
): Promise<void> {
  await apiClient(`/projects/${projectId}/members/${memberId}`, {
    method: "DELETE",
  });
}

export async function acceptInvitation(projectId: string): Promise<ProjectMember> {
  return apiClient<ProjectMember>(`/projects/${projectId}/members/accept`, {
    method: "POST",
  });
}

export async function transferOwnership(
  projectId: string,
  newOwnerUserId: string,
): Promise<{ status: string; new_owner: string }> {
  return apiClient(`/projects/${projectId}/members/transfer-ownership`, {
    method: "POST",
    body: { new_owner_user_id: newOwnerUserId },
  });
}
